import React from "react";
import {
  Autocomplete,
  Chip,
  Grid,
  IconButton,
  Popper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

import _ from "lodash";
import { useTranslation } from "react-i18next";
import SearchOutlinedComponent from "components/search/SearchOutlined.component";
import CachedIcon from "@mui/icons-material/Cached";
import PropTypes from "prop-types";
import { DateTime } from "luxon";
import DateTimePickerComponent from "components/datePicker/DateTimePicker.component";
import Card from "components/common/card/Card.component";

const ZoneSelectedSearchComponent = ({
  listClusters,
  zoneSelected,
  loadingZone = true,
  onRefresh = () => { },
  handleChangeZone = () => { },
  handleSearch = () => { },
  hasTimeSelect = false,
  onChangeValueDate = () => { },
  dateStart = null,
  dateEnd = null,
  valueData = '24h',
  onChangeDateStart = () => { },
  onChangeDateEnd = () => { },
  valueSearch
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Card>
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={10} sm={5.5} md={5.5} lg={5.5}>
          <Autocomplete
            multiple
            fullWidth
            noOptionsText={t('No Options')}
            options={listClusters}
            value={zoneSelected}
            loading={loadingZone}
            name="zone"
            size="small"
            onChange={(e, value) => handleChangeZone(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                //margin="normal"
                name="zone"
                label={
                  _.isEmpty(zoneSelected)
                    ? t("all-zones")
                    : t("select-one-or-more zones")
                }
                size="small"
              />
            )}
            PopperComponent={({ style, ...props }) => (
              <Popper
                {...props}
                style={{ ...style, zIndex: 20 }}
              />
            )}
          />
        </Grid>

        <Grid item xs={10} sm={5.5} md={5.5} lg={5.5}>
          <SearchOutlinedComponent
            label={t("Search")}
            handleSearch={handleSearch}
            valueSearch={valueSearch}
          />
        </Grid>
        <Grid
          item
          xs={2}
          sm={1}
          md={1}
          lg={1}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <IconButton
            onClick={() => onRefresh()}
            sx={{
              backgroundColor: theme.palette.primary.main,
              borderRadius: 2,
            }}
          >
            <CachedIcon
              sx={{
                color: "white",
                "&:hover": { color: theme.palette.primary.main },
              }}
              fontSize="small"
            />
          </IconButton>
        </Grid>

        {hasTimeSelect &&
          <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs="auto" sm={1.8} md={1.5} lg={1.5}>
              <Typography variant="h3" align="left" sx={{ fontSize: 18 }}>
                {t("Data relating to")}
              </Typography>
            </Grid>

            <Grid item xs sm={1.6} md={1.5} lg={1.5} mt={1}>
              <Chip
                label={t("Last 24 hours")}
                color="primary"
                onClick={() => onChangeValueDate("24h")}
                variant={valueData === "24h" ? "filled" : "outlined"}
              />
            </Grid>
            <Grid item xs={10} sm={4} md={4.2} lg={4.4}>
              <DateTimePickerComponent
                label={t("Start date and time")}
                value={dateStart}
                setValue={onChangeDateStart}
                maxDateTime={DateTime.now()}
              />
            </Grid>
            <Grid item xs={10} sm={4} md={4.4} lg={4.4}>
              <DateTimePickerComponent
                value={dateEnd}
                setValue={onChangeDateEnd}
                label={t("End date and time")}
                minDateTime={dateStart}
                maxDateTime={DateTime.now()}
              />
            </Grid>

          </Grid>}

      </Grid>
    </Card>
  );
};

ZoneSelectedSearchComponent.propTypes = {
  listClusters: PropTypes.array.isRequired,
  zoneSelected: PropTypes.array.isRequired,
  loadingZone: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  handleChangeZone: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
};
export default ZoneSelectedSearchComponent;
